import React, { useEffect, useRef } from "react";
import { string, func, bool, shape } from "prop-types";
import DOMPurify from "dompurify";

import ArrowLink from "../../../components/ArrowLink/ArrowLink.jsx";
import Icon from "../../../components/Icon/Icon.jsx";
import ImageElement from "../../../components/ImageElement/ImageElement.jsx";

export const propTypes = {
  title: string,
  description: string,
  stat: shape({
    value: string,
    description: string,
  }),
  ctaEyebrow: string,
  ctaTitle: string,
  ctaLink: shape({
    href: string,
    text: string,
    type: string,
  }),
  image: shape({
    srcSet: string,
    alt: string,
  }),
  link: shape({
    href: string,
    text: string,
    type: string,
  }),
  handleClose: func,
  focusOnOpen: bool,
};

const PinDetails = (props) => {
  const {
    title,
    description,
    stat,
    ctaEyebrow,
    ctaTitle,
    ctaLink,
    image,
    link,
    handleClose,
    focusOnOpen = true,
  } = props;

  const pinDetailsRef = useRef(null);

  useEffect(() => {
    if (focusOnOpen && pinDetailsRef.current) {
      pinDetailsRef.current.focus();
    }
  }, [focusOnOpen, pinDetailsRef]);

  return (
    <article className="pin-details" aria-label={title || "Location details"}>
      <button
        className="pin-details__close"
        aria-label="Close pin details"
        onClick={handleClose}
        ref={pinDetailsRef}
      >
        <Icon iconName="close" />
      </button>

      {image?.srcSet && (
        <div className="pin-details__image-wrapper">
          <ImageElement
            className="pin-details__image"
            sizes="(min-width: 680px) 545px, 100vw"
            {...image}
          />
        </div>
      )}

      <div className="pin-details__content">
        {(title || link) && (
          <div className="pin-details__title">
            {link ? <ArrowLink {...link} text={title} /> : title}
          </div>
        )}
        {description && (
          <div
            className="pin-details__description"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description),
            }}
          ></div>
        )}

        {(stat?.value || stat?.description) && (
          <div className="pin-details__stat">
            {stat.value && (
              <div className="pin-details__stat-number">{stat.value}</div>
            )}
            {stat.description && (
              <div
                className="pin-details__stat-description"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(stat.description),
                }}
              ></div>
            )}
          </div>
        )}

        {ctaTitle && (
          <div className="pin-details__cta-content">
            {ctaEyebrow && (
              <div className="pin-details__cta-eyebrow">{ctaEyebrow}</div>
            )}
            {ctaTitle && (
              <div className="pin-details__cta-title">{ctaTitle}</div>
            )}
            {ctaLink?.href && (
              <a href={ctaLink.href} className="link pin-details__cta-link">
                {ctaLink.text}
              </a>
            )}
          </div>
        )}
      </div>
    </article>
  );
};

PinDetails.propTypes = propTypes;
export default PinDetails;
